var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{attrs:{"icon":_vm.icon,"selected":_vm.selected},on:{"click-event":function($event){return _vm.$store.commit('setActiveTool', _vm.tool)}}})}
var staticRenderFns = []

export { render, staticRenderFns }